module.exports = __webpack_public_path__ + "static/footer-logo-top-0d99c2dea97ed0cefcb8e7414d5b557b.svg";